import { Component } from '@angular/core';

@Component({
  selector: 'promo-banner',
  imports: [],
  templateUrl: './promo-banner.component.html',
  styleUrl: './promo-banner.component.less'
})
export class PromoBannerComponent {

}
